import { useDispatch } from 'react-redux'
import { voipActiveCallPopUp } from '../../../../../../redux/actions/addOns/voip/voipActions'

export default function ActiveCall(props) {
  const { active_call_popup } = props
  const dispatch = useDispatch()

  const handleActiveCallPopUp = () => {
    dispatch(voipActiveCallPopUp(!active_call_popup))
  }

  return (
    <div className='active_call_popup position-absolute pointer' onClick={handleActiveCallPopUp}>
      <div className='border border-primary bg-white rounded-circle px-3 pt-3 pb-2 text-center'>
        <i className="las la-phone-volume text-primary"></i>
      </div>
    </div>
  )
}
